import dayjs from "dayjs";
import months from "../months.js";
export default {
  name: "CalendarFilteringPanel",
  props: {
    selectedDate: {
      type: Object,
      default: () => ({})
    },
    currentDate: {
      type: Object,
      default: () => ({})
    },
    projectList: {
      type: Array,
      default: () => []
    },
    isChangedByDay: {
      type: Boolean,
      default: false
    },
    usersList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      months: months.months,
      filters: {
        isWithoutTry: false,
        isWithTry: false,
        isFilterByProject: [],
        isFilterByUser: [],
        isShowAll: false
      }
    };
  },
  watch: {
    filters: {
      handler() {
        this.$emit("updateFilters", this.filters);
      },
      deep: true
    }
  },
  computed: {
    formatedSelectedDate() {
      return this.isChangedByDay
        ? `${this.day} ${this.formatedMonth.name} ${this.year}`
        : `${this.formatedMonth.name} ${this.year}`;
    },
    day() {
      return Number(this.selectedDate.format("D"));
    },
    month() {
      return Number(this.selectedDate.format("M"));
    },
    year() {
      return Number(this.selectedDate.format("YYYY"));
    },
    formatedMonth() {
      return this.months.find(month => month.number === this.month);
    }
  },
  methods: {
    setFilterIsShowAll() {
      if (this.filters.isShowAll) {
        this.filters.isWithTry = false;
        this.filters.isWithoutTry = false;
        this.filters.isFilterByProject = [];
        this.filters.isFilterByUser = [];
      }
    },
    setTryFilter(name) {
      if (this.filters[name]) {
        this.filters.isWithoutTry = false;
        this.filters.isWithTry = false;
        this.filters[name] = true;
      }
    },
    selectPrevious() {
      let newSelectedDate = {};
      if (!this.isChangedByDay) {
        newSelectedDate = dayjs(this.selectedDate).subtract(1, "month");
      } else {
        newSelectedDate = dayjs(this.selectedDate).subtract(1, "day");
      }
      this.$emit("setNewDate", newSelectedDate, this.isChangedByDay);
    },
    selectCurrent() {
      let newSelectedDate = dayjs(this.currentDate);
      this.$emit("setNewDate", newSelectedDate, this.isChangedByDay);
    },
    selectNext() {
      let newSelectedDate = {};
      if (!this.isChangedByDay) {
        newSelectedDate = dayjs(this.selectedDate).add(1, "month");
      } else {
        newSelectedDate = dayjs(this.selectedDate).add(1, "day");
      }
      this.$emit("setNewDate", newSelectedDate, this.isChangedByDay);
    },
    openMonthCalendar() {
      this.$emit("openMonthCalendar");
    }
  }
};
